import { __exports as i } from "../../../../../../../../../_virtual/index4.js";
import { __require as f } from "./email-template.js";
import { __require as l } from "./default.js";
import { __require as s } from "./inbox-composer.js";
import { __require as c } from "./html-block.js";
var t;
function O() {
  return t ? i : (t = 1, (function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), o.default = _;
    var a = f(), n = l(), u = s(), m = c(), e = {
      default: n.DEFAULT_CONFIG,
      email: a.EMAIL_TEMPLATE_CONFIG,
      inboxComposer: u.INBOX_COMPOSER_CONFIG,
      htmlBlock: m.HTML_BLOCK_CONFIG
    };
    function _() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default";
      if (!e[r])
        throw new Error("@intercom/intercom-sanitizer: You passed an invalid configuration, `".concat(r, "`,  to `sanitizeHtml`. The only valid configurations are: `").concat(Object.keys(e).join(", "), "`"));
      return e[r];
    }
  })(i), i);
}
export {
  O as __require
};
